import { useState } from "react";

export function useVideoStateController() {
  const [canPlay, setCanPlay] = useState(false);
  const [waiting, setIsWaiting] = useState(false);
  const [complete, setIsComplete] = useState(false);

  return {
    canPlay,
    waiting,
    complete,
    setCanPlay,
    setIsWaiting,
    setIsComplete,
    showLoader: (waiting || !canPlay) && !complete,
    showVideo: canPlay && !complete,
  };
}
